import { useEffect, useState } from "react"
import { Flex, Typography, Space, Button } from "antd"
import { ArrowLeftOutlined, HomeOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import BreadCrumb from "../../BreadCrumb";
import RoleManagement from "./role/RoleManagement";
import UserManagement from "./user/UserManagement";
import UserGroupManagement from "./group/UserGroupManagement";
import { useDispatch, useSelector } from "react-redux";
import { setFormType } from "../../../redux/slices/roleUserSlice";


const headerActionStyle = {
  width: "50%",
  textAlign: "right",
  lineHeight: "32px",
  height: "32px",
};

const UserAndRoleManagement = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState('user')
  const [submitRole, setSubmitRole] = useState(false)
  const [submitUser, setSubmitUser] = useState(false)
  const [submitGroup, setSubmitGroup] = useState(false)
  const [isEdit, setIsEdit] = useState(false)

  const { formType } = useSelector(state => state.roleUser);

  useEffect(() => {
    dispatch(setFormType(""))
  },[])

  const getActiveTab = (tab) => {
    if (tab === "role") {
      return t("Role");
    } else if (tab === "user") {
      return t("User");
    } else {
      return t('User Group')
    }

  };

  const breadCrumbItems = [
    {
      title: <HomeOutlined />,
      path: "/app/dashboard",
    },
    {
      title: t("Admin"),
      path: "/app/admin/config"
    },
    {
      title: getActiveTab(activeTab),
    },
  ]

  const handleSaveClick = () => {
    if (formType === "role") {
      setSubmitRole(true);
    } else if (formType === "user") {
      setSubmitUser(true)
    } else {
      setSubmitGroup(true)
    }
  }

  const saveRole = () => {

  }

  const saveUser = (values) => {
  }

  const saveGroup = () => {

  }

  const goBack = () => {
    setActiveTab(formType)
    dispatch(setFormType(""))
    setIsEdit(false)
  }

  const handleTabChange = (tab) => {
    setActiveTab(tab)
    dispatch(setFormType(""))
    setIsEdit(false)
  }

  return (
    <div className="p-10">
      <div >
        <BreadCrumb
          items={breadCrumbItems}
          marginb="16px"
        />

      </div>

      <Flex align="center" justify="space-between" className="mb-3" style={{height: "32px"}}>
        <Typography.Title level={4} style={{ margin: 0, padding: 0 }} >
          {/* {formType && <span><ArrowLeftOutlined style={{ marginRight: "12px" }} onClick={goBack} /></span>} */}
          {t("User & Role Management")}
          {/* {(formType === "role" && isEdit) ? "Edit Space Role" : formType === "role" ? t("New Space Role") : formType === "user" && isEdit ? t("Edit User") : formType === "user" ? t("New user") : formType === "group" && isEdit ? t("Edit Group") : formType === "group" ? "New Group" : t("User & Role Management")} */}
        </Typography.Title>
        {
          formType ?
            <div style={headerActionStyle}>
              <Button className="success-button" onClick={handleSaveClick}>{t("Save")}</Button>
            </div>
            : null
        }
      </Flex>
    
      {/* {
        !formType && */}
        <Flex align="center" justify="space-between" style={{ display: "flex", background: "#eeeef0", width: "max-content", borderRadius: "0.375rem", padding: "0.25rem" }}>
          <div className="cursor-pointer widget-tab" style={{ background: activeTab == "user" ? "#fff" : "#eeeef0" }} onClick={() => handleTabChange("user")}>{t("User")}</div>
          <div className="cursor-pointer widget-tab" style={{ background: activeTab == "group" ? "#fff" : "#eeeef0" }} onClick={() => handleTabChange("group")}>{t("User Group")}</div>
          <div className="cursor-pointer widget-tab" style={{ background: activeTab == "role" ? "#fff" : "#eeeef0" }} onClick={() => handleTabChange("role")}>{t("Space Role")}</div>
        </Flex>
      {/* } */}

      {
        activeTab === "role" ? <RoleManagement setIsEdit={setIsEdit} submitRole={submitRole} saveRole={saveRole} setSubmitRole={setSubmitRole} />
          : activeTab === "user" ? <UserManagement setIsEdit={setIsEdit} saveUser={saveUser} submitUser={submitUser} setSubmitUser={setSubmitUser} />
            : activeTab === "group" ? <UserGroupManagement setIsEdit={setIsEdit} submitGroup={submitGroup} saveGroup={saveGroup} setSubmitGroup={setSubmitGroup} />
              : null
      }
    </div>
  )
}

export default UserAndRoleManagement